export const isNotEmptyValueObject = (object: Record<string, unknown>) =>
  Object.values(object).some((value) => value)
